const optimizedResize = require('utilities/optimizedResize');

const resizeAndRescale = (el, retryCount) => {
	let parentWidth = $(el).parent().width();

	if (typeof retryCount === 'number' && isFinite(retryCount) && Math.floor(retryCount) === retryCount) {
		retryCount = retryCount;
	} else {
		retryCount = 0;
	}

	// this method is sometimes called before things are on screen and fully rendered
	// so we'll use setTimeout with exponential backoff to wait for rendering
	// and be kind to slow overworked school computers and tablets
	//
	// Also need to check and make sure the iframe is part of the document.
	if ((!$.contains(document, el) || parentWidth === 0) && retryCount < 20) {
		setTimeout(() => resizeAndRescale(el, retryCount + 1), (retryCount + 1) * 20);
		return;
	}
	let width = parseInt($(el).attr('width'));
	let scale = parentWidth / width;

	$(el).css({
		transformOrigin: 'top left',
		transform: 'scale(' + scale + ')'
	});
};

module.exports = {
	bind(el) {
		// store listener on el to remove on unbind
		el.iframeScaleListener = () => {
			resizeAndRescale(el);
		};

		optimizedResize.add(el.iframeScaleListener);
		el.iframeScaleListener();
	},
	unbind(el) {
		if (el.iframeScaleListener) {
			optimizedResize.remove(el.iframeScaleListener);
		}
	}
};
